const sld =
`<StyledLayerDescriptor version="1.0.0" xmlns="http://www.opengis.net/sld" 
  xmlns:gml="http://www.opengis.net/gml" xmlns:ogc="http://www.opengis.net/ogc" 
  xmlns:xlink="http://www.w3.org/1999/xlink" xmlns:xsi="http://www.w3.org/2001/XMLSchema-instance" 
  xsi:schemaLocation="http://www.opengis.net/sld http://schemas.opengis.net/sld/1.0.0/StyledLayerDescriptor.xsd">
 <NamedLayer> <Name>mapunitpoly</Name> <UserStyle> <FeatureTypeStyle>
 <Rule> <MinScaleDenominator>0.010000</MinScaleDenominator> <MaxScaleDenominator>250000.000000</MaxScaleDenominator>
 <PolygonSymbolizer> <Stroke>
 <CssParameter name="stroke">#3498DB</CssParameter>
 <CssParameter name="stroke-width">0.75</CssParameter>
 </Stroke> </PolygonSymbolizer>
 <TextSymbolizer> <Label>musym</Label>
 <Font> <CssParameter name="font-family">arial</CssParameter>
 <CssParameter name="font-weight">bold</CssParameter>
 <CssParameter name="font-size">7.00</CssParameter> </Font>
 <LabelPlacement> <PointPlacement>
 <AnchorPoint> <AnchorPointX>0.5</AnchorPointX> <AnchorPointY>0.5</AnchorPointY> </AnchorPoint> </PointPlacement> </LabelPlacement>
 <Fill> <CssParameter name="fill">#ff8000</CssParameter> </Fill> 
 <Halo><Fill> <CssParameter name="fill">#000000</CssParameter> </Fill> </Halo>
 </TextSymbolizer> </Rule>
 </FeatureTypeStyle> </UserStyle> </NamedLayer> </StyledLayerDescriptor>`;

 const SSURGO_URL = 'https://sdmdataaccess.sc.egov.usda.gov/tabular/post.rest';

 const createBoundary = async (boundary: any) => {
    const postData = {
        service: "aoi",
        request: "create", 
        aoicoords:JSON.stringify(boundary)
    };

    const response = await fetch(SSURGO_URL, {
        method: 'POST',
        body: JSON.stringify(postData),
    });

    if (!response.ok) {
        const message = `An error has occured: ${response.status}`;
        throw new Error(message);
    }

    const data = await response.json();

    const aoiId = data.id;

    return aoiId;
}

const registerSld =  async (aoiId: number, sld: string) => {
    const postData = {
        service: "aoi",
        request: "registersld", 
        sld: sld,
        aoiId: aoiId
    };

    const response = await fetch(SSURGO_URL, {
        method: 'POST',
        body: JSON.stringify(postData),
    });

    if (!response.ok) {
        const message = `An error has occured: ${response.status}`;
        throw new Error(message);
    }

    const data = await response.json();

    return data.sld_id;
}

const getRuleData =  async (aoiId: number, attributeKey: number) => {
    const postData = {
        service:"interpretation",
        request:"getruledata",
        attributekey: attributeKey,
        aoiId: aoiId
    };

    const response = await fetch(SSURGO_URL, {
        method: 'POST',
        body: JSON.stringify(postData),
    });

    if (!response.ok) {
        const message = `An error has occured: ${response.status}`;
        throw new Error(message);
    }

    const data = await response.json();

    return data;
}

const getRating = async (ruleData: string) => {
    const postData = {
        service:"interpretation",
        request:"getrating", 
        shortformdata: ruleData
    };

    const response = await fetch(SSURGO_URL, {
        method: 'POST',
        body: JSON.stringify(postData),
    });

    if (!response.ok) {
        const message = `An error has occured: ${response.status}`;
        throw new Error(message);
    }

    const data = await response.json();

    return data.interpresultid;
}

const queryData = async (query: string) => {
    const postData = {
        service:"query",
        query: query,
        format:'json+columnname'
      }

    const response = await fetch(SSURGO_URL, {
        method: 'POST',
        body: JSON.stringify(postData),
    });

    if (!response.ok) {
        const message = `An error has occured: ${response.status}`;
        throw new Error(message);
    }

    const data = await response.json();

    return data;
}

export const getInterpsByAoi = async (geom: any) => {

    const aoiId = await createBoundary(geom);
    const postData = {
        service:"interpretation",
        request: "getcatalog",
        aoiid:aoiId
      }
    const response = await fetch(SSURGO_URL, {
        method: 'POST',
        body: JSON.stringify(postData),
    });

    if (!response.ok) {
        const message = `An error has occured: ${response.status}`;
        throw new Error(message);
    }

    const interps = await response.json();

    return interps;
}

export const fetchSsurgoSoil = async (attributeKey: number, geom: any) => {
    const aoiId = await createBoundary(geom);
    const sldId = await registerSld(aoiId, sld);
    const ruleData = await getRuleData(aoiId, attributeKey);
    const interpresultId = await getRating(JSON.stringify(ruleData));

    if (interpresultId <= 0) {
        const message = `An error has occured`;
        throw new Error(message);
    }

    var query = 
        '~declareint(@AoiSoilThematicMapId)~\n' +
        `select @AoiSoilThematicMapId = ${interpresultId}; ` +
        'select LegendText, RgbString from SDA_Get_AoiSoilThematicMapLegend_By_AoiSoilThematicMapId (@AoiSoilThematicMapId); ' +
        'select MU.musym, MU.MUNAME, R.MapUnitRatingString [rating] ' +
        'from SDA_Get_AoiSoilThematicMapRating_By_AoiSoilThematicMapId (@AoiSoilThematicMapId) R, mapunit MU ' +
        'where R.MapUnitKey = MU.mukey';

    const tableData = await queryData(query);
    const overlayData = {aoiId: aoiId, sld_id: sldId, interpId: interpresultId};

    return { tableData, overlayData };
}